/**
 * Utils Factory
 */
(function() {

    'use strict';

    angular.module('itxApp.common')
        .service('productPopupSvc', ItxUtilsFct);

    ItxUtilsFct.$inject = [
        '$rootScope',
        'ItxSizeGuideSvc',
        'ngDialog',
        'ItxLoaderFct',
        'Product',
        'imDispatcherService'
    ];

    /**
     * Utilities shared in the app
     * @constructor
     */
    function ItxUtilsFct(
        $rootScope,
        ItxSizeGuideSvc,
        ngDialog,
        ItxLoaderFct,
        Product,
        imDispatcherService
    ) {

        var service = {
            showProductPopup: showProductPopup,
            openProductPopup: openProductPopup,
            openStockAvailability: openStockAvailability,
            getProductSizes: getProductSizes,
            stockProductDialog: stockProductDialog,
            noStockProductDialog: noStockProductDialog,
            openHelpPage: openHelpPage,
            openStock: openStock
        };
        return service;

        function openStockAvailability(product) {
            ngDialog.open({
                template: '<itx-product-stock-availability data="ngDialogData" on-close-dialog="closeThisDialog()"></itx-product-stock-availability>',
                className: 'new-modal hg-modal-md ma-dialog ma-dialog-full stock-notification ngdialog-theme-plain',
                plain: true,
                showClose: true,
                data: {
                    product: product,
                    selectedSize: product.state.selectedSize
                }
            });
        }

        function getProductSizes(product){
            var uniqueSize = false;
            var sizes;

            if (product && product.activeDetail.colors && product.activeDetail.colors.length) {
                sizes = ItxSizeGuideSvc.removeDuplicates(product.activeDetail.colors[product.state.selectedColorIndex].sizes);

                if (sizes.length === 1 && sizes[0].name === '01') {
                    uniqueSize = true;
                    //_this.selectedSize = sizes[0];
                }
                return sizes;
            }
            return [];
        }

        function showProductPopup(productId, categoryId, colorId) {
            /**
             * Get product and cache it for avoid duplicate calls when revisiting inside the swiper
             */
            if (window.productPopupOpen) {
                return;
            }
            ItxLoaderFct.show();
            $rootScope.$digest();
            //var scrollTop = $(window).scrollTop();
            window.productPopupOpen = true;

            var p = new Product(productId, colorId, null, categoryId);
            p.fetch().then(function(product) {
                var subscription;
                $('body, html').addClass('product-popup');
                var $pDialog = ngDialog.open({
                    template: '<itx-product-dialog product="ngDialogData.product" not-editable="ngDialogData.notEditable" ignore-color-stock="ngDialogData.ignoreColorStock" close-dialog="closeThisDialog()"></itx-product-dialog>',
                    plain: true,
                    className: 'ma-product-dialog ngdialog-theme-plain',
                    showClose: true,
                    data: {
                        product: product,
                        notEditable: !joyr.catalog.utils.isOpenForSale(),
                        ignoreColorStock: '' + colorId
                    },
                    preCloseCallback: function() {
                        subscription();
                        window.productPopupOpen = false;
                        imDispatcherService.sortEvent('pageview', product);
                    }
                });

                subscription = $rootScope.$on('ngDialog.opened', function(e, $dialog) {
                    if ($dialog.prop('id') === $pDialog.id) {
                        ItxLoaderFct.hide();
                    }
                });

            }).Catch(function() {
                ItxLoaderFct.hide();
                $rootScope.$digest();
                window.productPopupOpen = false;
            });
        }

        function openStock(product, selectedColorIndex, productApiLegacy) {
            ngDialog.open({
                template: '<itx-product-stock color="ngDialogData.color" detail="ngDialogData.detail" reference="ngDialogData.reference" close-dialog="closeThisDialog()"></itx-product-stock>',
                plain: true,
                className: 'new-modal ma-modal-lg  store-check-dialog ngdialog-theme-plain',
                showClose: true,
                data: {
                    color: product.colors[selectedColorIndex || 0],
                    reference: product.reference,
                    detail: productApiLegacy
                }
            });
        }

        function openProductPopup(product, colorId) {
            if (window.productPopupOpen) {
                return;
            }
            if ( product && product.fetched) {
                window.productPopupOpen = true;
                ngDialog.open({
                    template: '<itx-product-dialog product="ngDialogData.product"></itx-product-dialog>',
                    plain: true,
                    className: 'ma-product-dialog ngdialog-theme-plain',
                    showClose: true,
                    data: {
                        product: product
                    },
                    preCloseCallback: function() {
                        imDispatcherService.sortEvent('pageview', product);
                        window.productPopupOpen = false;
                        ItxLoaderFct.hide();
                    }
                });
            } else {
                ItxLoaderFct.show();
                var p = new Product(product, colorId);
                p.fetch().then(function(product) {
                    ItxLoaderFct.hide();
                    window.productPopupOpen = true;

                    // No sizes == no stock
                    var productSizes = service.getProductSizes(product);

                    if(productSizes.length != 0){
                        service.stockProductDialog(product);
                    } else {
                        service.noStockProductDialog(product);
                    }

                }).Catch(function(err) {
                    ItxLoaderFct.hide();
                    service.noStockProductDialog(product);
                    console.err('err', err)
                });
            }
        }

        function stockProductDialog (product) {
            ngDialog.open({
                template: '<itx-product-dialog product="ngDialogData.product"></itx-product-dialog>',
                plain: true,
                className: 'ma-product-dialog ngdialog-theme-plain',
                showClose: true,
                data: {
                    product: product,
                },
                onOpenCallback:true,
                preCloseCallback: function() {
                    imDispatcherService.sortEvent('pageview', product);
                    window.productPopupOpen = false;
                }
            });
        }

        function openHelpPage(product) {
            // imProductService.eventHelpPage(product);
            ngDialog.open({
                template: '<itx-contact close="closeThisDialog()"></itx-contact>',
                plain: true,
                className: 'product-info ngdialog-theme-plain new-modal ma-modal-lg ',
                showClose: true
            });

            // document.body.addEventListener('click', function(e) {
            //     if($(e.target).hasClass('openChat')) {
            //         dialog.close();
            //         ItxChatSvc.showChat();
            //     }
            // });
        }

        function noStockProductDialog (product) {
            ngDialog.open({
                template: '<itx-nostock-product-dialog product="ngDialogData.product"></itx-nostock-product-dialog>',
                plain: true,
                className: 'ma-dialog new-modal ma-modal-md ma-dialog-full ngdialog-theme-plain',
                showClose: true,
                data: {
                    product: product
                },
                onOpenCallback:true,
                preCloseCallback: function() {
                    imDispatcherService.sortEvent('pageview', product);
                    window.productPopupOpen = false;
                }
            });
        }

    }
})();